var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-area"},[_c('div',{staticClass:"support-box shadow"},[_c('Header'),_c('Body')],1),_c('Button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }